import React from 'react';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { experiences } from '../../constants';
import styles from './Exp.module.scss';

const ExperienceCard = ({ experience }) => (
  <VerticalTimelineElement
    contentStyle={{ 
      background: 'linear-gradient(135deg, #1e1b3c 0%, #2d2654 100%)', 
      color: '#fff',
      padding: '1.8rem',
      borderRadius: '15px',
      border: '1px solid rgba(255, 255, 255, 0.1)',
      boxShadow: '0 15px 40px rgba(0, 0, 0, 0.4)',
    }}
    contentArrowStyle={{ borderRight: '7px solid #1e1b3c' }}
    date={experience.date}
    iconStyle={{ 
      background: experience.iconBg,
      boxShadow: '0 0 0 4px #1e1b3c, 0 0 20px rgba(0, 0, 0, 0.3)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
    icon={
      <div className="flex justify-center items-center w-full h-full">
        <img
          src={experience.icon}
          alt={experience.company_name}
          className="w-3/5 h-3/5 object-contain"
        />
      </div>
    }
    className={styles.timelineElement}
  >
    <div className={styles.cardContent}>
      <h3 className={styles.title}>{experience.title}</h3>
      <p className={styles.company}>{experience.company_name}</p>
      <ul className={styles.pointsList}>
        {experience.points.map((point, index) => (
          <li key={`experience-point-${index}`} className={styles.point}>
            {point}
          </li>
        ))}
      </ul>
    </div>
  </VerticalTimelineElement>
);

const Experience = ({ innerRef, darkMode }) => {
  return (
    <div ref={innerRef} className={styles.experienceContainer} id="experience">
      <h2 
        className={styles.sectionHeadText}
        style={{
          color: darkMode ? '#f5f5f5' : '#1a1a1a',
          border: `2px solid ${darkMode ? 'rgba(65, 105, 225, 0.3)' : 'rgba(65, 105, 225, 0.5)'}`,
          background: darkMode 
            ? 'linear-gradient(135deg, rgba(65, 105, 225, 0.1), rgba(147, 51, 234, 0.1))'
            : 'linear-gradient(135deg, rgba(255, 255, 255, 0.8), rgba(240, 240, 255, 0.9))',
          boxShadow: darkMode 
            ? '0 8px 25px rgba(0, 0, 0, 0.3)' 
            : '0 8px 25px rgba(65, 105, 225, 0.15)',
          backdropFilter: 'blur(10px)',
        }}
      >
        Work Experience
      </h2>
      <div className={styles.timelineContainer}>
        <VerticalTimeline animate={true} lineColor="rgba(255, 255, 255, 0.2)">
          {experiences.map((experience, index) => (
            <ExperienceCard key={index} experience={experience} />
          ))}
        </VerticalTimeline>
      </div>
    </div>
  );
};

export default Experience;
